import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ButtonComponent } from './button.component';
import { Unit } from '../../../models/entities/unit';

@Component({
    selector: 'app-unit-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class UnitButtonComponent extends ButtonComponent implements OnChanges
{
    @Input() unit: Unit;

    constructor() {
        super();
        this.type = 'link';
        this.svg = 'unit';
        this.hostClass += ' unit-button';
        this.iconClassesCallback = () => this.iconClassSet.add('align-items-start').add('pl-1');
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);

        if ('unit' in changes) {
            this.label = this.getLabel();
        }
    }

    getLabel() {
        let label = '';
        if (this.unit.title) {
            if (this.unit.title.length > 25) {
                this.tooltip = this.unit.title;
                label += this.unit.title.slice(0, 25) + '...';
            } else {
                label += this.unit.title;
            }
        }

        let address = '';
        if (this.unit.address) {
            address += this.unit.address.line1 + '<br>';
            if (this.unit.address.line2) {
                address += this.unit.address.line2 + '<br>';
            }
            address += (this.unit.address.city ? `${this.unit.address.city}, ` : '') + `${this.unit.address.region} ${this.unit.address.postalCode}`;
        }

        return label + `<span class="description-text">${address}</span>`;
    }
}
